module.exports = __webpack_public_path__ + "h5/img/praise01.1b924315.png";